<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';
import CFSupportCircle from '@/shared/components/CFSupportCircle.vue';
import CFNotificationBell from '@/shared/components/CFNotificationBell.vue';

const emit = defineEmits(['click']);
</script>

<template>
    <header
        class="fixed inset-x-0 top-0 z-30 flex items-center justify-between bg-black px-4 py-2 text-white md:hidden"
    >
        <button
            type="button"
            class="cursor-pointer p-2 text-white"
            @click="emit('click')"
        >
            <span class="sr-only">{{ $t('general.open_sidebar') }}</span>
            <CFIcon
                name="navigation-menu"
                size="24"
            />
        </button>

        <div class="flex items-center gap-2">
            <!-- <CFSearchCircle />-->
            <CFSupportCircle />
            <CFNotificationBell />
        </div>
    </header>
</template>
